import React, { useState } from "react";
import { FormGroup, Label } from "reactstrap";

import { useBookingsMapContext } from "../../BookingsMap/Context/BookingsMapContext";

import { Switch } from "../../../shared/Switch/Switch";
import { SelectPeopleList } from "../FindPeopleButton/SelectPeopleList";
import { Input } from "../../../shared/Input/Input";

export const BookOnBehalf = () => {
  const [bookOnBehalf, setBookOnBehalf] = useState(false);
  const { bookOnBehalfUser, setBookOnBehalfUser, setNotifyAssignee } =
    useBookingsMapContext();

  return (
    <div className="BookOnBehalf SearchWorkplaceForm__switch mb-4">
      <Switch
        name="bookOnBehalf"
        title="Book on behalf of"
        value={bookOnBehalf}
        onChange={() => {
          if (bookOnBehalfUser) {
            setBookOnBehalfUser(undefined);
          }

          setBookOnBehalf((prev) => !prev);
        }}
      />

      <span className="text-14 text-secondary mb-1 font-weight-light lh-0">
        Adding a user will assign the reservation to them instead of you.
      </span>

      {bookOnBehalf && (
        <>
          <SelectPeopleList bookOnBehalf />

          <div className="mt-3 flex-center">
            <FormGroup className="flex-a-center Notify mb-0">
              <Input
                type="checkbox"
                id="notifyAssigne"
                name="notifyAssigne"
                data-cy="notifyAssigne"
                onChange={() => setNotifyAssignee((prev) => !prev)}
              />
              <Label for="notifyAssigne" className="checkbox_label">
                <p className="pr-1 font-weight-light">Notify assignee</p>
                <span className="checkbox_box"></span>
              </Label>
            </FormGroup>
          </div>
        </>
      )}
    </div>
  );
};
